import React, {FC, Fragment} from 'react';
import messages from '../messages';
import {useColorWebDeleteForm} from './use-color-web-delete-form';
import Button from 'components/button';
import {useTranslation} from 'react-i18next';
import {Alert, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import {ObjectId} from 'types/object-id';

interface Props {
  message?: string;
  onDismiss: () => void;
  colorId: ObjectId;
}

const ColorWebArchiveModal: FC<Props> = props => {
  const {onDismiss, colorId} = props;
  const {t} = useTranslation();

  const {isLoading, submit, errorMessage} = useColorWebDeleteForm(
    onDismiss,
    colorId
  );

  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">{t(...messages.actionOnColors())}</span>
      </ModalHeader>
      <ModalBody className="">
        {!!errorMessage && <Alert color="danger">{errorMessage}</Alert>}

        <div>
          <Row>{t(...messages.deleteAlertMessage())}</Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="important" onClick={submit} isLoading={isLoading}>
          {t(...messages.yesImSure())}
        </Button>
        <Button color="secondary" onClick={onDismiss}>
          {t(...messages.cancel())}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

export default ColorWebArchiveModal;
